// extracted by mini-css-extract-plugin
module.exports = {"sticky":"Sticky_sticky__GhIcR","sticky--bottom":"Sticky_sticky--bottom__11y-A","sticky--top":"Sticky_sticky--top__3wviq"};